import app from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(app, "us-central1");

const callNetgsmAction = async (netgsmAction, data = {}) => {
  const callable = httpsCallable(functions, "createUser");
  return (await callable({ netgsmAction, ...data })).data;
};

export const sendNetgsmTestSms = async ({ phone, message }) => {
  return callNetgsmAction("sendTestSms", { phone, message });
};

export const sendBalanceReminderSms = async ({ contactIds, messageTemplate }) => {
  return callNetgsmAction("sendBalanceReminderSms", { contactIds, messageTemplate });
};
